export default {"src":"/_next/static/media/footer-google-play-button.cb47e12a.svg","height":56,"width":189,"blurWidth":0,"blurHeight":0};